import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import packView from "./components/packView";
import { loadMoreList, serchSelect } from "@/mixins/index";
import addpack from "./components/addpack";
export default {
  name: "pack",
  mixins: [loadMoreList, serchSelect],
  components: {
    addpack: addpack,
    uploadImagetow: uploadImagetow,
    packView: packView
  },
  data: function data() {
    return {
      pagingReqFn: "paymentProductsData",
      pagingReqValue: "data",
      drawer: false,
      GamesServersList: [],
      gameList: []
    };
  },
  activated: function activated() {
    var _this = this;

    this.$api.paymentGamesServersAll().then(function (res) {
      if (res.code == 0) {
        _this.GamesServersList = res.data;
      }
    });
    this.$api.paymentGamesData().then(function (res) {
      if (res.code == 0) {
        _this.gameList = res.data;
      }
    });
  },
  created: function created() {
    this.getList();
  },
  methods: {
    openView: function openView(row) {
      this.$refs.packView.init(row);
    },
    del: function del(data) {
      var _this2 = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'paymentProductsDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};